import React, {Component} from 'react';
import MuiButton from '@material-ui/core/Button';

class Button extends Component {

  handleChange = (event, index, value) => {
    this.props.onChange(value);
  }

  render() {
    return (
        <MuiButton variant="contained" disabled={this.props.disabled}
          id={this.props.id}
          data-testid={this.props['data-testid']}
          onClick={this.props.onClick}
          className={this.props.className}>{this.props.label}</MuiButton>
    );
  }
}


export default Button;
